import React from "react";
import { useStyles } from "../ScoreboardStyles.css";
import GameSessionScore from "../../scoreboard-content/scores/GameSessionScore";
import DecisionReviewContent from "../../scoreboard-content/review/top/DecisionReviewContent";
import { Typography } from "@mui/material";
const ScoreboardTopReview = ({
    matchedDecisions,
    activeStep,
    sessionInfo,
    feedbackMode,
    sessionType,
    loading,
}) => {
    const classes = useStyles();

    console.log(matchedDecisions);

    return (
        <div className={classes.scoreboardContainer}>
            {feedbackMode !== "exam" ? (
                <DecisionReviewContent
                    matchedDecisions={matchedDecisions}
                    activeStep={activeStep}
                    sessionInfo={sessionInfo}
                    sessionType={sessionType}
                    loading={loading}
                />
            ) : (
                <Typography
                    style={{
                        color: "white",
                        background: "black",
                        fontSize: "2vw",
                        marginTop: "0.5vw",
                        marginBottom: "0.5vw",
                        minHeight: "3vw",
                        top: 0,
                        left: 0,
                        marginLeft: "auto",
                        marginRight: "auto",
                    }}
                >
                    Feedback unavailable in {feedbackMode} mode
                </Typography>
            )}
        </div>
    );
};

export default ScoreboardTopReview;
